import React, { PropsWithChildren } from "react";
import { classes } from "lib/actions/util";
import DropdownActionMenu, {
  ActionMenuItem,
} from "components/elements/Dropdown/DropdownActionMenu";
import ListItemWithSecondaryButton from "./ListItemWithSecondaryButton";
import SvgMore from "../../icons/24/actions/more.svg";

export default function ListItemWithContext({
  ref,
  contextMenuItems,
  children,
  selected = false,
  onClickCard,
  contextMenuWidth = 210,
  onContextMenuOpen,
  inlineRightContent,
}: PropsWithChildren<{
  contextMenuItems: ActionMenuItem[];
  selected?: boolean;
  onClickCard?: (event: React.MouseEvent) => void;
  contextMenuWidth?: number;
  onContextMenuOpen?: () => void;
  inlineRightContent?: React.ReactNode;
}> & {
  ref?: React.RefObject<HTMLDivElement>;
}) {
  return (
    <ListItemWithSecondaryButton
      ref={ref}
      primaryButtonProps={{
        onClick: onClickCard,
      }}
      inlineRightContent={inlineRightContent}
      secondaryButtonProps={{
        colourSchemeVariant: "custom",
        className: classes(
          "transition-colors duration-200",
          selected ? "bg-green-100" : "bg-neutral-50",
        ),
      }}
      secondaryButtonContent={
        <DropdownActionMenu
          dropdownWidth={contextMenuWidth}
          className="h-full"
          onOpen={onContextMenuOpen}
          buttonContent={
            <div className="flex h-full w-full justify-center">
              <SvgMore className="w-6 text-icon-normal hover:text-icon-hover group-hover/context:text-icon-hover" />
            </div>
          }
          items={contextMenuItems}
        />
      }
    >
      {children}
    </ListItemWithSecondaryButton>
  );
}
